import { render, staticRenderFns } from "./CopyToClipboardButton.vue?vue&type=template&id=5c64c863&scoped=true&"
import script from "./CopyToClipboardButton.vue?vue&type=script&lang=ts&"
export * from "./CopyToClipboardButton.vue?vue&type=script&lang=ts&"
import style0 from "./CopyToClipboardButton.vue?vue&type=style&index=0&id=5c64c863&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c64c863",
  null
  
)

export default component.exports